import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

const savePath = '/admin/bookings/:code/cancel' as const;

export type CancelBookingForm = {
  reasonId: number;
  comment?: string;
};

export const useCancelBooking = () => {
  return useMutation<
    number,
    unknown,
    { code: string; body: CancelBookingForm },
    unknown
  >({
    mutationFn: async (payload) =>
      apiMutation(
        'PUT',
        {
          path: savePath,
          params: { code: payload.code },
        },
        payload.body
      ),
    onSuccess: () => {
      message.success('Booking successfully cancelled');
    },
    onError: (_, payload) => {
      message.error(`Failed to cancel booking #${payload.code}`);
    },
  });
};
